define('features',['featureflag'], function(FeatureFlag) {
    'use strict';

    function Features(edap) {
        var features = this,
            featuresInternal,
            err;

        /**
         *  Validate
         */

        if (!edap || !edap.hasOwnProperty('edapVersion')) {
            throw new TypeError('Features: must pass in EDAP when creating a new instance');
        }

        if (!(features instanceof Features)) {
            err = new TypeError('Features must be called with the "new" keyword');
            edap.error(err);
            throw err;
        }


        /**
         *  Container to hold all the internal data for the Features Object.
         *
         *  @private
         */
        features.internal = {};
        featuresInternal = features.internal;


        /**
         *  Add a callback to be executed after all the FeatureFlags are loaded via load().
         *  If load() has already been called then the callback is executed immedaitely.
         *
         *  @public
         *  @param {Function} [cb] - Function to be executed after FeatureFlags are loaded
         */
        features.onLoad = function(cb) {
            var error;

            if (typeof cb !== 'function') {
                error = new TypeError('onLoad(): must be passed a function');
                edap.error(error);
                throw error;
            }

            if (featuresInternal.hasLoaded) {
                try {
                    cb();
                } catch (e) {
                    edap.error(e);
                }
            } else {
                featuresInternal.loadCallbacks.push(cb);
            }
        };


        /**
         *  Loads all the FeatureFlag instances. This is a clean slate method that will remove any
         *  other existing FeatureFlags. If you wish to add just 1 new Feature then you should use
         *  features.addFeatureFlag() instead. After all FeatureFlags are loaded it will execute any
         *  functions that were stored via onLoad().
         *
         *  NOTE: This function is designed to be only be called once. If you wish to re-init your
         *        FeatureFlags then you can use reset() to allow you to call load() again.
         *
         *  @public
         *  @param {Array} [featureFlags] - Array of FeatureFlag objects to store
         */
        features.load = function(featureFlags) {
            var logName = 'load',
                i,
                len,
                error;

            if (!(featureFlags instanceof Array)) {
                err = new TypeError(logName + '(): featureFlags must be an Array of FeatureFlag instances');
                edap.error(error);
                throw error;
            }

            if (featuresInternal.hasLoaded === true) {
                error = new TypeError(logName + '(): Features has already been loaded, try calling reset() first');
                edap.error(error);
                throw error;
            }

            // When load is called we always zero out the existing list of Features
            featuresInternal.featureList = {};

            // Load all the FeatureFlags
            for (i = 0, len = featureFlags.length; i < len; i++) {
                features.addFeatureFlag(featureFlags[i]);
            }

            featuresInternal.hasLoaded = true;

            // Now execute all the onLoad callbacks since the FeatureFlags have been loaded
            for (i = 0, len = featuresInternal.loadCallbacks.length; i < len; i++) {
                try {
                    featuresInternal.loadCallbacks[i](edap);
                } catch (e) {
                    edap.error(e);
                }
            }

            featuresInternal.loadCallbacks = [];
        };


        /**
         *  Add a single FeatureFlag into the Feature List. It will overwrite an existing feature with the
         *  same name in the list.
         *
         *  @public
         *  @param {FeatureFlag} [featureFlag] - FeatureFlag object to store
         */
        features.addFeatureFlag = function(featureFlag) {
            var error;

            if (!(featureFlag instanceof FeatureFlag)) {
                error = new TypeError('addFeatureFlag(): attempting to load a non-FeatureFlag model');
                edap.error(error);
                throw error;
            }

            featuresInternal.featureList[featureFlag.get('name')] = featureFlag;
        };


        /**
         *  Gets a single FeatureFlag object by name
         *
         *  @public
         *  @param {String} [name] - name of the Feature Flag object to get
         *  @returns {Object} - returns the FeatureFlag object if it is in the list, otherwise null
         */
        features.getFeature = function(name) {
            if (featuresInternal.featureList.hasOwnProperty(name)) {
                return featuresInternal.featureList[name];
            }

            return null;
        };


        /**
         *  Gets the value of a property of a specific Feature Flag
         *
         *  @public
         *  @param {String} [featureName] - name of the Feature Flag object to get
         *  @param {String} [propertyName] - name of the property to get from the Feature Flag instance
         *  @returns {Object} - returns the value of the property of a specific Feature Flag, or null
         */
        features.getFeatureProperty = function(featureName, propertyName) {
            var ff = features.getFeature(featureName);

            if (ff !== null) {
                return ff.get(propertyName);
            }

            return null;
        };


        /**
         *  Resets the internal data structures. Doing this will allow you to call
         *  load() again.
         *
         *  @public
         */
        features.reset = function() {
            featuresInternal.featureList = {};
            featuresInternal.loadCallbacks = [];
            featuresInternal.hasLoaded = false;
        };


        /**
         *  Constructor
         */

        // Init the internal data structures
        features.reset();

        return features;
    }

    return Features;
});

